import React, { useMemo } from "react";
import { useRouter } from "next/router";
import styled from "styled-components";
import Link from "next/link";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownToggle from 'react-bootstrap/DropdownToggle';
import DropdownMenu from 'react-bootstrap/DropdownMenu';
import DropdownItem from 'react-bootstrap/DropdownItem';

const productsMap = new Map([
  ["/products/EINSoleProp", "Sole Proprietor / Individual"],
  ["/products/EINPartnership", "Partnership"],
  ["/products/EINCCorp", "Corporation"],
  ["/products/EINSCorp", "S-Corporation"],
  ["/products/EINEstate", "Estate of Deceased Individual"],
  ["/products/EINNonProfit", "Non-Profit Organization"],
  ["/products/EINLLC", "Limited Liability Company"],
  ["/products/EINTrust", "Trust"],
  ["/products/EINPSC", "Personal Service Corporation"],
  ["/products/EINChurch", "Church Organization"],
]);

const StyledProductDropdown = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: row;
  button {
    padding: 0;

    border: none !important;
    box-shadow: none !important;
    background: #FFFFFF !important;

    font-family: 'MerriweatherBold';
    color: #244f74 !important;
    text-transform: uppercase;
    text-decoration: underline !important;
    text-align: left;

    &:before {
      display: inline-block;
      padding-right: 7px;
      content: "\\00BB";
      line-height: 0px;
      font-size: 26px;
      border: none;
    }

    &:after {
      display: none;
    }
  }

  .dropdown-menu {
    padding-top: 8px;
    padding-bottom: 8px;

    background-color: #f3f3f3;

    .dropdown-item {
      padding: 0;
      a {
        padding: .25rem 1.5rem;
        font-family: 'MerriweatherLight';
        font-size: 14px;
        line-height: calc(1.42857rem * (14 / 16));
        color: #212529;
        text-transform: uppercase;
        text-shadow: none;
        text-decoration: none;
        display: block;
      }

      &:hover {
        background-color: #244f74;

        a {
          color: #ffffff;
        }
      }
    }
  }
  @media ${({ theme }) => theme.devices.tablet} {
    flex-direction: column;
    gap: 0px;
  }

`;

function ProductDropdown() {
  const router = useRouter();
  const productTitle = useMemo(() => {
    return productsMap.get(router?.pathname);
  }, [router]);

  return (
    <StyledProductDropdown>
      Need to change entity type?
      <Dropdown>
        <DropdownToggle id="product-dropdown">
          {productTitle}
        </DropdownToggle>
        <DropdownMenu>
          {Array.from(productsMap.keys()).map(route => (
            <DropdownItem key={route}>
              <Link href={`${route}`}>
                <a>{productsMap.get(route)}</a>
              </Link>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </StyledProductDropdown>
  );
}

export default ProductDropdown;
